<template>
	<v-btn
		v-bind="$attrs"
		:disabled="!canCopy"
		@click="copy"
	>
		<slot />
	</v-btn>
</template>
<script>
/**
 *  Button that accepts a copy-data prop that will copy said data to your clipboard
 *  when clicked.
 */
export default {
	name: 'CopyToClipboardButton',
	props: {
		copyData: {
			type: [ String, Number, ],
			required: true,
		}
	},

	data () {
		return {
			copied: false,
		};
	},

	computed: {
		/**
		 * Disable button if there's no data to copy.
		 *
		 * @returns {boolean} Wheter we can copy data
		 */
		canCopy: function () {
			return this.copyData !== undefined;
		}
	},

	methods: {

		/**
		 * Copy the data to the clipboard. Flash the button green for 2 seconds to indicate success.
		 *
		 * @returns {void}
		 */
		copy () {
			navigator.clipboard.writeText(this.copyData.toString());
			this.copied = true;
			setTimeout(() => (this.copied = false), 2000);
		}
	}
};
</script>
